import config from '../config';
import io from 'socket.io-client';
import { AuthenticationService } from '../services';

export const SocketHelper = {
  create: () => io(config.apiBaseUrl, {
    transports: ["polling"],
    auth: {
      token: `Bearer ${AuthenticationService.getAuthToken()}`,
    },
  })
}